import { useMutation, useQuery } from 'react-query';
import { useServiceError } from '@/hooks';
import {
  generateInventoryRegisterBook,
  generatePurchaseReport,
  generatePurchaseReportArrayBuffer,
} from './ReportPurchase.service';
import { ReportPurchaseParams } from './ReportPurchase.types';
import notificationError from '@/utils/functions/notificationError';

export function useGenerateInventoryRegisterBook() {
  return useMutation(generateInventoryRegisterBook, {
    onError(error) {
      notificationError(error);
    },
  });
}

export function usePurchaseReport() {
  const mutation = useMutation((obj: ReportPurchaseParams) =>
    generatePurchaseReport(obj),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useReportTemplateGeneratePurchase({
  enabled,
  ...params
}: ReportPurchaseParams & { enabled: boolean }) {
  return useQuery(
    ['report/template/purchase', params],
    () => generatePurchaseReportArrayBuffer(params),
    {
      enabled: !!params.purchaseReleaseId && !!params.format && !!enabled,
      onError(error) {
        notificationError(error);
      },
    },
  );
}
